module.exports = __webpack_public_path__ + "img/undraw_Short_bio_re_fmx0.f941a43f.svg";